import React from "react";
const SubNavBar = ({ active, setActiveTab }) => {
  return (
    <div className="flex gap-16px border-b border-primary-100 dark:border-accent-700 text-sm font-medium text-accent-400 dark:text-accent-300">
      <div
        onClick={() => setActiveTab("my-details")}
        className={`cursor-pointer px-1 pb-10px
        ${
          active === "my-details"
            ? "active | text-primary-500 border-b-[3px] border-primary-500"
            : ""
        }`}
      >
        My details
      </div>
      <div
        onClick={() => setActiveTab("password")}
        className={`cursor-pointer px-1 pb-10px
      ${
        active === "password"
          ? "active | text-primary-500 border-b-[3px] border-primary-500"
          : ""
      }`}
      >
        Password
      </div>
      <div
        onClick={() => setActiveTab("notifications")}
        className={`cursor-pointer px-1 pb-10px
      ${
        active === "notifications"
          ? "active | text-primary-500 border-b-[3px] border-primary-500"
          : ""
      }`}
      >
        Notifications
      </div>
    </div>
  );
};
export default SubNavBar;
